<template>
  <section class="section">
    <h1 class="title is-4">Carga de archivos por hospital</h1>
    <div class="columns">
      <div class="column is-8">
        <b-field label="Hospital" :type="errors.hospital && 'is-danger'" :message="errors.hospital">
          <b-select v-model="form.hospital" placeholder="Selecciona un hospital" expanded required>
            <option v-for="h in hospitals" :key="h.code" :value="h.code">{{ h.name }}</option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field label="Fecha de carga" :type="errors.fecha && 'is-danger'" :message="errors.fecha">
          <b-datepicker
            v-model="form.fecha"
            :first-day-of-week="1"
            placeholder="Selecciona la fecha"
            locale="es-ES"
            required
            icon="calendar-today"
            :disabled="isSubmitting"
          />
        </b-field>
      </div>
    </div>

    <div v-if="form.hospital && form.fecha">
      <b-field label="Archivo">
        <b-upload v-model="form.file" class="file-label"
                  accept=".xls,.xlsx"
                  @input="handleInputFile">
            <span class="file-cta">
                <b-icon class="file-icon" icon="upload"></b-icon>
                <span class="file-label">Seleccionar archivo</span>
            </span>
          <span class="file-name" v-if="form.file">
                {{ form.file.name }}
            </span>
        </b-upload>
      </b-field>
    </div>

    <div class="table-container" v-if="loadFile">
      <b-table
        :data="rows"
        :striped="true"
        :mobile-cards="true"
        :row-class="getRowClass"
      >
        <template #empty>
          <section class="section has-text-centered">
            <p v-if="!loading">Por favor seleccione un archivo válido</p>
          </section>
        </template>

        <b-table-column field="name" label="Nombre" v-slot="props">
          {{ props.row.name }}
        </b-table-column>

        <b-table-column field="last_name" label="Paterno" v-slot="props">
          {{ props.row.last_name }}
        </b-table-column>

        <b-table-column field="other_name" label="Materno" v-slot="props">
          {{ props.row.other_name }}
        </b-table-column>

        <b-table-column field="folio" label="Folio Paciente" v-slot="props">
          {{ props.row.folio }}
        </b-table-column>

        <b-table-column field="birthdate" label="Nacimiento" v-slot="props">
          {{ props.row.birthdate }}
        </b-table-column>

        <b-table-column field="sex" label="Sexo" v-slot="props">
          {{ props.row.sex }}
        </b-table-column>

        <b-table-column field="study" label="Estudio" v-slot="props">
          <div v-for="study in props.row.studies" :key="study.lapi_code" style="margin-bottom: .5rem;">
            <strong>Subpartida: {{ study.subpartida }} - Nombre SEDENA:  {{ study.sedena_name }}</strong><br />
            <small>Clave LAPI: {{ study.lapi_code }} - Nombre LAPI: {{ study.lapi_description }}</small>
          </div>
        </b-table-column>

        <b-table-column field="order" label="OrdenNew" v-slot="props">
        </b-table-column>

        <b-table-column field="status" label="Estado" v-slot="props">
        </b-table-column>
      </b-table>
    </div>

    <div class="is-flex is-justify-content-flex-end is-align-items-center" style="gap: .5rem;">
      <b-button @click="reset" type="is-success is-light" :disabled="isSubmitting">Limpiar</b-button>
      <b-button @click="submit" type="is-primary" :loading="isSubmitting" v-if="validFile">Enviar</b-button>
    </div>
  </section>
</template>

<script>
import readXlsxFile from "read-excel-file";

export default {
  name: "Import",
  components: {},
  data() {
    return {
      hospitals: [],
      form: {
        hospital: null,
        file: null, // File
        fecha: null // Date
      },
      isSubmitting: false,
      errors: {},
      rows: [],
      loading: false,
      validFile: false,
      loadFile: false
    };
  },
  computed: {
    fileList() {
// Normaliza a Array<File>
      return this.form.files ? Array.from(this.form.files) : [];
    }
  },
  mounted() {
    this.wrapper = document.getElementById("main-wrapper");
    this.wrapper.classList.add("is-expanded");
    this.prepareData();
  },
  methods: {
    prepareData() {
      this.$loader.show();
      this.$http.get("/sedena/companies").then(({ data }) => {
        this.hospitals = Array.isArray(data.data) ? data.data : [];
      }).catch(err => {

      }).finally(() => {
        this.$loader.hide();
      });
    },
    onFiles(files) {
// Hook opcional por si quieres validar tipos/tamaños
// console.log('files added', files)
    },
    validate() {
      this.errors = {};
      if (!this.form.hospital) this.errors.hospital = "Selecciona un hospital.";
      if (!this.form.fecha) this.errors.fecha = "Selecciona la fecha de carga.";
      return Object.keys(this.errors).length === 0;
    },
    async submit() {
      if (!this.validate()) return;
      this.isSubmitting = true;
      try {
        const printer = Number.parseInt(localStorage.getItem('printerManager_printer')) || 1;
        const payload = {
          company: this.form.hospital,
          date: this.form.fecha ? this.form.fecha.toISOString().slice(0, 10) : null,
          data: this.rows,
          printer
        };
        this.$loader.show();
        this.$http.post("/sedena/work", payload).then(({ data }) => {
          this.$buefy.dialog.confirm({
            title: "Carga exitosa",
            message: "El archivo se ha cargado correctamente.",
            confirmText: "Aceptar",
            type: "is-success",
            canCancel: false,
            onConfirm: () => {
              this.$router.push({ name: "sedena-import-show", params: { uuid: data.data.uuid } });
            }
          });
        }).catch(error => {
          this.$alfalab.showError(error, true);
        }).finally(() => {
          this.$loader.hide();
        });
      } catch (e) {
        this.$buefy.toast.open({ message: "Ocurrió un error al enviar.", type: "is-danger" });
      } finally {
        this.isSubmitting = false;
      }
    },
    reset() {
      this.form.hospital = null;
      this.form.file = null;
      this.form.fecha = null;
      this.errors = {};
      this.rows = [];
      this.validFile = false;
      this.loading = false;
    },
    rowHasErrors(row) {
      //console.log(!!row[0], !!row[1], !!row[2], !!row[3], !!row[4], !!row[5], !!row[6], !!row[7], !!row[8]);
      const result = !(!!row[0] && !!row[1] && !!row[2] && !!row[3] && !!row[4] && !!row[5] && !!row[6] && !!row[7] && !!row[8] && !!row[9]);
      //console.log(result)
      return result;
    },
    hasErrors(rows) {
      return rows.some(row => this.rowHasErrors(row));
    },
    isValidFile(rows) {
      if (rows.length < 2) return false;
      const header = rows[0];
      if (header.length < 9) return false;
      const expectedHeader = [
        "Given Name",
        "First Surname",
        "Second Surname",
        "Patient ID",
        "Birth Date",
        "Sex",
        "Subpartida",
        "Test Name",
        "LAPI Code",
        "LAPI Description"
      ];
      for (let i = 0; i < expectedHeader.length; i++) {
        if (header[i] !== expectedHeader[i]) return false;
      }
      return true;
    },
    handleInputFile(e) {
      readXlsxFile(this.form.file).then((rows) => {
        if (!this.isValidFile(rows)) {
          this.$buefy.dialog.alert({
            title: "Error en el archivo",
            message: "El archivo no tiene el formato correcto. Revisa que las columnas sean las adecuadas y que se genero con el OCR de la SEDENA."
          });
          return;
        }
        const hasFileErrors = this.hasErrors(rows.slice(1));
        if (hasFileErrors) {
          this.$buefy.dialog.alert({
            title: "Error en el archivo",
            message: "El archivo contiene filas incompletas. Revisa que todas las columnas estén completas."
          });
        } else {
          this.validFile = true;
        }
        const processRows = {};
        rows.slice(1).forEach(row => {
          let tmpRow = null;
          const hasErrors = this.rowHasErrors(row);
          if (processRows[`folio_${row[3]}`]) {
            tmpRow = processRows[`folio_${row[3]}`];
            if(!tmpRow.studies.find(s => s.lapi_code === row[8])) {
              tmpRow.studies.push({
                subpartida: row[6],
                lapi_code: row[8],
                sedena_name: row[7],
                lapi_description: row[9]
              });
            }
          } else {
            tmpRow = {
              name: row[0],
              last_name: row[1],
              other_name: row[2],
              folio: row[3],
              birthdateFormated: row[4],
              birthdate: this.formatDate(row[4]),
              sex: row[5],
              studies: [{
                subpartida: row[6],
                lapi_code: row[8],
                sedena_name: row[7],
                lapi_description: row[9]
              }]
            };
            tmpRow.has_errors = hasErrors;
            processRows[`folio_${row[3]}`] = tmpRow;
          }
          this.loadFile = true;
        });
        const newRows = [];
        for (const i in processRows) {
          newRows.push(processRows[i]);
        }
        this.rows = newRows;
      });
    },
    formatDate(dateString) {
      const [dia, mes, anio] = dateString.split("/");
      const fecha = new Date(anio, mes - 1, dia);
      const formato = `${fecha.getFullYear()}/${String(fecha.getMonth() + 1).padStart(2, "0")}/${String(fecha.getDate()).padStart(2, "0")}`;
      return formato;
    },
    getRowClass(row, index) {
      return row.has_errors ? "sedena-row-has-errors" : "";
    }
  }
};
</script>

<style scoped>

</style>